import { IInfinityDataGridStore } from './infinityDataGrid.interface';

export const infinityDataGridInitialState: IInfinityDataGridStore = {
};

// ordinal stamped on rows that repeat another row's id within one page (broken backend data, see LB-5184)
export const DUPLICATE_ROW_INDEX = '__duplicateRowIndex';
